import { Stack } from '@mui/material'
import { isoDateStringToLocalFormat, OrderStatus, OrderStatusIcon, QuickViewBox, tokens } from 'ComponentLibrary'
import { TextWithEllipsis, Typography } from 'ComponentLibrary/src/piazza/text'
import { useTranslation } from 'react-i18next'
import { useCurrentResolvedLocale } from 'ClientPortal/src/i18n/currentLocale'

type StatusInfoBoxProps = {
    status: OrderStatus
    displayDate?: string
    statusMessage?: string
}

export function OrderStatusInfoBox({ status, displayDate, statusMessage }: StatusInfoBoxProps) {
    const { t } = useTranslation('terminology', { keyPrefix: 'common' })
    const locale = useCurrentResolvedLocale()
    const statusLabel = t(`orderStatuses.${status}.label`)

    return (
        <QuickViewBox
            padding={tokens.SizingSpacing200}
            justifyContent="space-between"
            sx={{
                border: `${tokens.SizingBorderS} solid ${tokens.ColorBorderDefault}`,
                borderRadius: tokens.SizingCornerM,
            }}
        >
            <Stack direction="row" width="100%" justifyContent="space-between">
                <Stack direction="row" gap={tokens.SizingSpacing150} alignItems="center">
                    <OrderStatusIcon variant="square" state={status} size="23px" label={statusLabel} />
                    <Typography variant="headline2" color={tokens.ColorTextBoldest}>
                        {statusLabel}
                    </Typography>
                </Stack>
            </Stack>
            <Stack direction="column">
                <Typography variant="textS" color={status === 'blocked' ? tokens.ColorTextDangerSubtle : tokens.ColorTextBold}>
                    {t(`orderStatuses.${status}.longLabel`)}
                </Typography>
                {statusMessage && (
                    <TextWithEllipsis
                        typographyProps={{
                            variant: 'textS',
                            color: tokens.ColorTextDangerSubtle,
                        }}
                        tooltipText={statusMessage}
                    >
                        {statusMessage}
                    </TextWithEllipsis>
                )}
                {displayDate && (
                    <Typography variant="textS" color={tokens.ColorTextDefault}>
                        {isoDateStringToLocalFormat(displayDate, false, locale)}
                    </Typography>
                )}
            </Stack>
        </QuickViewBox>
    )
}
